// extracted by mini-css-extract-plugin
module.exports = {"headerLabel":"styles_headerLabel__2YZ98","sidebarButtons":"styles_sidebarButtons__220yR"};